import assign from 'object-assign';
import expandCalendarEventIfSpilling from './expandCalendarEventIfSpilling';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';
import { getCalendarEventsStore } from '../store/store';
import { getTimestamp, userDate } from 'owa-datetime';

/**
 * Method that returns the calendar event corresponding to the key.
 * @param key calendar event key.
 * @returns the calendar event.
 */
export default function getCalendarEventByKey(key: CalendarEventKey): CalendarEvent {
    if (!key) {
        return null;
    }
    let event: CalendarEvent = null;
    if (key.itemId) {
        const actualEvent = getCalendarEventsStore().getCalendarEvent(key.itemId);
        if (actualEvent) {
            const expandedEvents = expandCalendarEventIfSpilling(actualEvent).filter(
                e => getTimestamp(e.Start) === key.timestamp
            );
            if (expandedEvents && expandedEvents.length > 0) {
                event = expandedEvents[0];
            }
        }
    }
    if (!event && key.timestamp) {
        event = assign(new CalendarEvent(), {
            Start: userDate(key.timestamp),
            End: userDate(key.timestamp),
        });
    }
    return event;
}
